import React, { useContext, useEffect, useState } from 'react'
import Card from "../UI/card/Card";
import Input from "../UI/input/Input";
import { Icon } from "@iconify/react";
import classes from "../add/add.module.scss";
import Button from "../UI/button/Button";
import { images } from '../../constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import LoadingSpinner from '../UI/loadingSpinner/LoadingSpinner';
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../env';
import LoginContext from '../../contexts/loginContext'; 

interface Biometrics {
  parishId: string;
  name: string;
  productName: symbol;

}
const EditBiometrics = () => {
  const { token } = useContext(LoginContext);
  const params = useParams();
  const { biometricsId } = params;
    console.log(biometricsId);

  const [data, setData] = useState<Biometrics[]>([]);

  const [biometricsData, setBiometricsData] = useState(null);
  const [biometricsError, setBiometricsError] = useState("");

  const [biometricsName, setBiometricsName] = useState('');
  const [serialNumber, setSerialNumber] = useState('');
  const [deviceId, setDeviceId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(true)
  const [selectedItem, setSelectedItem] = useState<string>('');

  // Fetch Biometrics data
  useEffect(() => {
    let isMounted = true;

    const fetchBiometrics = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/Biometrics/GetBiometricsbySerialNumber?serialNumber=${biometricsId}`, {
          headers: {
            Authorization: `Bearer ${token}`, 
            "Content-Type": "application/json",
          },
        });

        if (isMounted && response.data?.data) {
          const data = response.data.data;
          
          setBiometricsName(data.productName || "");
          setSerialNumber(data.serialNumber || "");
          setDeviceId(data.deviceId || "");
          setSelectedItem(data.parishId || ""); 
        }
      } catch (error: any) {
        if (isMounted) {
          setBiometricsError(error.response?.data?.message || "Failed to fetch data");
          toast.error(error.response?.data?.message || "Error fetching biometrics data");
        }
      }
    };

    fetchBiometrics();

    return () => {
      isMounted = false;
    };
  }, [biometricsId, token]);


  // Fetch Parish Data
  useEffect(() => {
    let isMounted = true; 

    const fetchData = async () => {
      try {
        const response = await axios.get<{ data: Biometrics[] }>(`${API_BASE_URL}/Parish/GetAllParish`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (isMounted) {
          setData(response.data.data);
          setStatus(false);
        }
      } catch (error) {
        if (isMounted) {
          setStatus(false);
          toast.warn('Error fetching Parish Data.');
        }
      }
    };

    fetchData();

    return () => {
    isMounted = false;
  };
  }, [token]);

  const handleChange = (setter: React.Dispatch<React.SetStateAction<any>>) => {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
      setter(e.target.value);
    };
  };

  const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedItem(event.target.value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate form fields
    if (!biometricsName?.trim() || !serialNumber?.trim() || !deviceId?.trim() || !selectedItem) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      toast.error('Please fill in all the required fields.');
      return;
    }

    setIsLoading(true);

    try {
      const updatedBiometricData = new FormData();
      updatedBiometricData.append("id", biometricsId ?? "");
      updatedBiometricData.append("productName", biometricsName);
      updatedBiometricData.append("serialNumber", serialNumber);
      updatedBiometricData.append("deviceId", deviceId);
      updatedBiometricData.append("parishId", selectedItem);

      const updateBiometricsEndpoint = `${API_BASE_URL}/Biometrics/UpdateBiometric`;

      const response = await axios.put(updateBiometricsEndpoint, updatedBiometricData, {
        headers: {
          "Content-Type": "application/json", 
          Authorization: `Bearer ${token}`,
        },
      });

      setIsLoading(false);

      if (response.status === 200) {
        toast.success('Biometric data updated successfully.');
        
        setBiometricsName("");
      setSerialNumber("");
      setDeviceId("");
      setSelectedItem('');
      } else {
        toast.error('Failed to update biometric data.');
      }
    } catch (error: any) {
      setIsLoading(false);

      if (error.response) {
        toast.error(error.response.data?.message || 'Failed to update biometric data.');
      } else {
        toast.error('An unexpected error occurred while updating biometric data.');
      }
    } finally {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // Usage:
  const biometricsNameHandler = handleChange(setBiometricsName);
  const serialNumberHandler = handleChange(setSerialNumber);
  const deviceIdHandler = handleChange(setDeviceId);

  return (
    <div className={classes.add__container}>
          {status ? (
        <LoadingSpinner />
      ): (
        <>
            <div className={classes.add__left}>
              <Card>
                  <p>Changes to be updated</p>

                  <div className={classes.card__info}>
                      <div>
                          <div className={classes.title}>Name of Biometric</div>
                          <div className={classes.value}>
                              {biometricsName ? biometricsName : 'Undefined'}
                          </div>
                      </div>

                      <div>
                          <div className={classes.title}>Serial Number</div>
                          <div className={classes.value}>
                              {serialNumber ? serialNumber : 'Undefined'}
                          </div>
                      </div>

                      <div>
                          <div className={classes.title}>Device Id</div>
                          <div className={classes.value}>
                              {deviceId ? deviceId : 'Undefined'}
                          </div>
                      </div>
                  </div>
              </Card>
            </div>
            
            <div className={classes.add__right}>
                <Card>
                  <div className={classes.card__edit}>
                      <h3 className={classes.subTitle}>
                          <Icon icon="fluent:edit-16-regular" width="24" />
                          {'Commit'}
                      </h3>

                      <div className={classes.img_wrapper}>
                          <img
                              className={classes.pic}
                              //@ts-ignore
                              src={images.bio}
                              alt=""
                          />
                      </div>

                      {/* input fileds */}
                      <form
                          onSubmit={(e)=> {
                              handleSubmit(e)
                          }}
                      >
                          <div className={classes.form__control}>
                              <label htmlFor="Name">Name of Biometrics</label>
                              <input
                                  id="Name of Biometrics"
                                  type='text'
                                  placeholder='Enter biometrics name'
                                  value={biometricsName}
                                  onChange={biometricsNameHandler}
                              />
                          </div>

                          <div className={classes.form__control}>
                              <label htmlFor="Name">Serial Number</label>
                              <input
                                  id="Serial Number"
                                  type='text'
                                  placeholder='Enter serial number'
                                  value={serialNumber}
                                  onChange={serialNumberHandler}
                              />
                          </div>

                          <div className={classes.form__control}>
                              <label htmlFor="Name">Device Id</label>
                              <input
                                  id="Device Id"
                                  type='text'
                                  placeholder='Enter device id'
                                  value={deviceId}
                                  onChange={deviceIdHandler}
                              />
                          </div>

                          {/* the value of this category is going to be based on dynamicity */}
                          <div className={classes.form__control}>
                            <label htmlFor="Category">Parish</label>
                                <select
                                    value={selectedItem}
                                    onChange={handleSelect}
                                    style={{
                                        padding: '1rem 1.5rem',
                                        border: '1px solid gainsboro',
                                        outline: 'gray',
                                        textTransform: 'capitalize',
                                        backgroundColor: 'transparent',
                                        borderRadius: '10px',
                                        minWidth: '300px',
                                        boxShadow: '0 0 12px 0 rgba(0, 0, 0, 0.05)',
                                        //@ts-ignore
                                        '@media screen and (maxWidth: 300px)': {
                                        minWidth: 'auto',
                                    },
                                }}
                                >
                                    <option value={''}>Select Value</option>
                                    {data.map((item)=>(
                                        <option key={item.parishId} value={item.parishId}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                          </div>

                          <div className={classes.btn__wrapper}>    
                              <Button type="submit" disabled={isLoading}>
                                  {isLoading ? <img  src={images.loader} alt="loader" /> : "Upload"}
                              </Button>
                          </div>
                      </form>
                  </div>
                </Card>
            </div>
        </>
      )}

  </div>
  )
}

export default EditBiometrics